// extracted by mini-css-extract-plugin
module.exports = {"transfer-wrapper":"transfer-wrapper","transfer-slider":"transfer-slider","title":"title","bm-btn":"bm-btn","icon":"icon","btn-prev":"btn-prev","btn-next":"btn-next"};